import { gql } from 'apollo-boost';

export const SEND_EMAIL_CAMPAIGN_TEST = gql`
    mutation($data: SendEmailCampaignTestInput!) {
        sendEmailCampaignTest(data: $data) {
            ... on SendEmailCampaignTestSuccess {
                success
                message
            }
            ... on UserNotFound {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;

